export const Global = Object.freeze({
    // BASE_API_URL: "http://localhost:8080"
    BASE_API_URL: "https://getbetter-be.herokuapp.com"
})